import { render, staticRenderFns } from "./oldLogin.vue?vue&type=template&id=1079beee&scoped=true"
import script from "./oldLogin.vue?vue&type=script&lang=js"
export * from "./oldLogin.vue?vue&type=script&lang=js"
import style0 from "./oldLogin.vue?vue&type=style&index=0&id=1079beee&prod&lang=scss"
import style1 from "./oldLogin.vue?vue&type=style&index=1&id=1079beee&prod&lang=scss&scoped=true"
import style2 from "./oldLogin.vue?vue&type=style&index=2&id=1079beee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1079beee",
  null
  
)

export default component.exports